import React from 'react';
import emptyStateImage from '../../../../images/delivery-blocks-template-empty-state.svg';
import './delivery-blocks-schedules-empty-state.scss';
import { useTranslation } from 'react-i18next';

const DeliveryBlocksSchedulesEmptyState: React.FC = () => {
	const { t } = useTranslation();

	return (
		<div
			data-test-id="delivery-blocks-schedules-empty-state"
			className="delivery-blocks-schedules-empty-state-container"
		>
			<img className="delivery-blocks-schedules-empty-state-image" src={emptyStateImage} />
			<span className="delivery-blocks-schedules-empty-state-title">
				{t('DELIVERY_BLOCKS_SETTINGS.EMPTY_STATE_TITLE')}
			</span>
			<span className="delivery-blocks-schedules-empty-state-text">
				{t('DELIVERY_BLOCKS_SETTINGS.EMPTY_STATE_TEXT')}
			</span>
		</div>
	);
};

export default DeliveryBlocksSchedulesEmptyState;
